namespace Matrix.Data {
    export interface DataReportListColumnsRequest extends Serenity.ServiceRequest {
        QueryType?: DataQueryType;
        ObjectName?: string;
        Sql?: string;
        ParameterValues?: { [key: string]: string };
    }
}
